import React, { Component } from "react";
import "./navigationButtons.scss";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class NavigationButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSemGerente: false,
      modalExisteCadastro: false
    };
  }

  render() {
    let { currentStep } = this.props.navegation;
    let { nextCustomButton, disabledProx, mensage, openModalSemGerente, openModalExisteCadastro} = this.props;
    let showBack = false;

    if (currentStep && currentStep.Id > 0) {
      showBack = true;
    }

    let classNext = disabledProx ? "next-icon" : "next";

    return (
      <>
        <div className="navigationButtons">
          <div className="col-50">
            {mensage && <p>{mensage}</p>}
            <p>Campos marcados com (*) são de preenchimento obrigatório!</p>
          </div>
          <div className="col-50">
            <div className="col-50">
              {showBack && (
                <button onClick={this.previousPage} className="previous">
                  Anterior
                </button>
              )}
            </div>
            <div className="col-50">
              {!nextCustomButton && (
                <button
                  onClick={() => {
                    if (openModalSemGerente) {
                      this.setState({ modalSemGerente: true });
                    } 

                    if (openModalExisteCadastro) {
                      this.setState({ modalExisteCadastro: true });
                    }  

                    if (!openModalSemGerente && !openModalExisteCadastro)  {
                      this.nextPage();
                    }
                  }}
                  className={classNext}
                  disabled={disabledProx}
                >
                  Próximo
                </button>
              )}
              {nextCustomButton}
            </div>
          </div>
        </div>
        
        {/* Modal sem gerente */}
        <Dialog
          open={this.state.modalSemGerente}
          onClose={() => this.setState({ modalSemGerente: true })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle 
            id="alert-dialog-title"
            style={{borderBottom: '1px solid gray'}}
          >
            <span style={{color: 'green'}}>Atenção</span>
          </DialogTitle>
          <DialogContent style={{borderBottom: '1px solid gray'}}>
            <DialogContentText id="alert-dialog-description">
              Você não informou o código do seu Gerente na B&T. Obtenha com o seu contato na B&T e informe para facilitar o processo do seu cadastro.
              <br/>
              Deseja informar o Gerente? 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{backgroundColor: 'green'}}
              onClick={() => this.setState({ modalSemGerente: false, modalExisteCadastro: false })}
              // color="primary"
            >
              <span style={{color: 'white'}}>Sim</span>              
            </Button>
            <Button
              variant="contained" 
              style={{backgroundColor: 'green'}}
              onClick={() => {
                this.setState({ modalSemGerente: false });

                if (!this.state.modalExisteCadastro) {
                  this.nextPage();
                }                
              }}
              // color="primary"
              autoFocus
            >
              <span style={{color: 'white'}}>Não, seguir sem Gerente</span> 
            </Button>
          </DialogActions>
        </Dialog>

         {/* Modal cadastro existe */}
         <Dialog
          open={this.state.modalExisteCadastro}
          onClose={() => this.openModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle 
            id="alert-dialog-title"
            style={{borderBottom: '1px solid gray'}}
          >
            <span style={{color: 'green'}}>Atenção</span>
          </DialogTitle>
          <DialogContent style={{borderBottom: '1px solid gray'}}>
            <DialogContentText id="alert-dialog-description">
              Prezado cliente, caso você já possua cadastro conosco e utilize o aplicativo Easyway Remessas, 
              seu acesso ao aplicativo ficará suspenso após o envio dos dados até que sejam analisados. 
              <br/>
              Continua com o preenchimento?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              variant="contained" 
              style={{backgroundColor: 'white'}}
              onClick={() => this.setState({ modalSemGerente: false, modalExisteCadastro: false })}
            >
              <span style={{color: 'green'}}>Cancelar</span>
            </Button>
            <Button 
              variant="contained" 
              autoFocus
              style={{backgroundColor: 'green'}}
              onClick={() => {
                this.setState({ modalExisteCadastro: false });

                if (!this.state.modalSemGerente) {
                  this.nextPage();
                }                
              }}
            >
              <span style={{color: 'white'}}>Sim</span>
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  nextPage = () => {
    this.props.setValidateFieldsAction(true);

    let next = null;
    let { currentStep } = this.props.navegation;
    let { steps } = this.props;
    if (steps) {
      if (!currentStep) {
        next = steps[0];
      } else {
        let index = this.findIndexElement(steps, currentStep, "Id");
        next = steps[index + 1];
      }
    }

    if (this.props.validateFields) {
      this.props
        .validateFields()
        .then((validationForm) => {
          if (validationForm.length === 0) return false;

          return validationForm.find((o) => {
            return !o.valid;
          });
        })
        .then((r) => {
          if (next && next.URL && !r) {
            this.props.setCurrentStepAction(next);
            this.props.history.push(next.URL);
          }

          this.props.setValidateFieldsAction(false);
        });
    } else {
      if (next && next.URL) {
        this.props.setCurrentStepAction(next);
        this.props.history.push(next.URL);
      }

      this.props.setValidateFieldsAction(false);
    }
  };

  findIndexElement = (list, element, props) => {
    return list.findIndex((e, i) => {
      return e[props] === element[props];
    });
  };

  previousPage = () => {
    let { currentStep } = this.props.navegation;
    let { steps, history, setCurrentStepAction } = this.props;
    let index,
      previous = null;

    if (steps) {
      index = this.findIndexElement(steps, currentStep, "Id") - 1;
      if (index < 0) {
        previous = { URL: "vamosComecar" };
        setCurrentStepAction({});
      } else {
        previous = steps[index];

        setCurrentStepAction(previous);
      }
      history.push(previous.URL);
    }
  };
}

export default NavigationButtons;
